import type { MaterializedMenuProduct } from '@iheartjane/data-access';
import { materializedMenuProductQueryOptions } from '@iheartjane/data-access/react-query';
import type { QueryClient } from '@tanstack/react-query';
import type { LoaderFunctionArgs } from 'react-router';

import { ensureNumericId } from '@jane/kiosk/util';

export type ProductDetailLoaderType = {
  product: MaterializedMenuProduct;
  productId: number;
};

export const productDetailLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs): Promise<ProductDetailLoaderType> => {
    const { productId, storeId } = params;

    const numericProductId = ensureNumericId(productId);

    const product = await queryClient.query({
      staleTime: 'static',
      ...materializedMenuProductQueryOptions({
        productId: numericProductId,
        storeId: ensureNumericId(storeId),
      }),
    });

    if (!product) {
      throw new Error(
        '[productDetailLoader]: No product returned - it is likely out of stock or hidden by the store.'
      );
    }

    return {
      product,
      productId: numericProductId,
    };
  };
